'use strict';

export default class AvailabilityFutureFunctionsComponent {
	public restrict: any;
	public scope: any;
	public template: any;
	public controller: any;
	public controllerAs: any;
	public bindToController: any;

  constructor() {
    this.restrict = 'E',
      this.scope = {
        date: '=',
        functions: '='
      }
    this.template = require('./future.functions.component.html');

    this.controller = AvailabilityFutureFunctionsController;
    this.controllerAs = 'ctrl';
    this.bindToController = true;
  }
}

/* @ngInject */
class AvailabilityFutureFunctionsController {
	public $scope: any;
	public $rootScope: any;
	public $log: any;
	public $uibModal: any;
	public dataService: any;
	public isExpaneded: any;

  constructor($scope, $rootScope, $log, $uibModal, dataService) {
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$log = $log;
    this.$uibModal = $uibModal;
    this.dataService = dataService;
    this.isExpaneded = false;
  }

  setExpanded() {
    this.isExpaneded = !this.isExpaneded;
  }
}